export default __webpack_public_path__ + "static/media/Twenty.eb414203.jpeg";